<div class="chat-page">
  <div class="chat-page-header">
    <h2>
      <i class="pi pi-comments"></i>
      Assistant de création de règles
      <p-tag severity="warn" value="POC" styleClass="poc-tag" />
    </h2>
  </div>

  <!-- Active chat -->
  <ng-container *ngIf="activeEquipmentId">
    <div class="chat-container">
      <app-rule-creation-chat [equipmentId]="activeEquipmentId" />
    </div>
  </ng-container>
</div>
